module.exports = __webpack_public_path__ + "img/paylocity.7a5644ed.svg";